import Cookies from "js-cookie";

const TokenKey = "Admin-Token";
const RefreshKey = "Admin-Refresh-Token";
const AuthUser = "Auth-User-UZNATURE";
const RefreshToken = "Refresh-Token";
const SidebarKey = "Admin-Sidebar";

var expire = new Date(new Date().getTime() + 120 * 60 * 1000);

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function setRefresh(token) {
  return Cookies.set(RefreshToken, token);
}
export function setSidebar(val) {
  localStorage.setItem(SidebarKey, JSON.stringify(response.data.sidebar));
  //   return Cookies.set(SidebarKey, JSON.stringify(val));
}
export function getSidebar() {
  return localStorage.getItem(SidebarKey);

  //   return Cookies.get(SidebarKey);
}
export function getRefresh() {
  return Cookies.get(RefreshToken);
}
export function removeSidebar() {
  return localStorage.removeItem(SidebarKey);
  //   return Cookies.remove(SidebarKey);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function removeRefresh() {
  return Cookies.remove(RefreshToken);
}
export function setUserData(user) {
  localStorage.setItem(AuthUser, JSON.stringify(user));

  // return Cookies.set(AuthUser, user, { expires: expire });
}
export function getUserData() {
  return localStorage.getItem(AuthUser);
}
export function removeUserData() {
  return Cookies.remove(AuthUser);
}
